<script lang="ts" setup>
import type { AppVersion } from "mws-platform-ts-sdk-v2-admin";

import { useGetAppVersionsQuery } from "@/appVersions/api/queries";
import AppVersionSupportButton from "@/appVersions/components/AppVersionSupportButton.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import PaginatedTable from "@/common/components/table/PaginatedTable.vue";
import type { TableColumn } from "@/common/components/table/types";

definePage({
  meta: {
    auth: ["Developer.Access"],
  },
});

const columns: TableColumn<AppVersion>[] = [
  { key: "version", label: "Version", type: "text" },
  { key: "supported", label: "Supported", type: "bool" },
  { key: "actions", label: "Actions", type: "slot", isSortable: false },
];

const breadcrumbs = [{ label: "App Versions", to: "#" }];
</script>

<template>
  <PageWrapper
    title="App Versions"
    :breadcrumb-links="breadcrumbs"
  >
    <PaginatedTable
      :collection-query-fn="useGetAppVersionsQuery"
      :columns="columns"
      description="Marking a version as not supported forces clients on that version to update before they can continue."
    >
      <template #actions="{ item }">
        <AppVersionSupportButton :app-version="item" />
      </template>
    </PaginatedTable>
  </PageWrapper>
</template>
